// extracted by mini-css-extract-plugin
export var contentWithMainEgg = "tps-1-module--content-with-main-egg--GAFMk";
export var mainEggContainer = "tps-1-module--main-egg-container--6iOcC";
export var contentWithSpecificationsCard = "tps-1-module--content-with-specifications-card--zIFxi";
export var specificationsCard = "tps-1-module--specifications-card--LQfdP";
export var columns = "tps-1-module--columns--RLAY9";
export var column = "tps-1-module--column--OjtGB";
export var columnEgg = "tps-1-module--column-egg--mfTSx";
export var columnEgg1Container = "tps-1-module--column-egg-1-container--Ao6-T";
export var smallList = "tps-1-module--small-list--IjqeL";